module.exports = __webpack_public_path__ + "static/media/heart_rate.d6321bbe.svg";